import script from "./SkillSettingTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillSettingTable.vue?vue&type=script&setup=true&lang=js"

import "./SkillSettingTable.vue?vue&type=style&index=0&id=036695dd&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-036695dd"]])

export default __exports__